import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Patient } from '../models/patient.model';
import { Router } from '@angular/router';
import { SelectedPatientService } from '../services/selected-patient.service';

@Component({
  selector: 'app-patient-search-table',
  templateUrl: './patient-search-table.component.html',
  styleUrls: ['./patient-search-table.component.scss'],
  standalone: false
})
export class PatientSearchTableComponent {
  @Input() patients: Patient[] = [];
  private router = inject(Router);
  private selectedPatientService: SelectedPatientService = inject(SelectedPatientService);


  displayedColumns: string[] = [
    'masterPatientIdentifier',
    'fullName',
    'DOB',
    'gender',
    'isActiveInReggie',
    'activeInEDS',
  ];
  dataSource = new MatTableDataSource<Patient>(this.patients);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patients']) {
      this.dataSource.data = this.patients;
    }
  }

  patientDetails = (patient: Patient) =>  {
    this.selectedPatientService.selectPatient(patient);
    this.router.navigate(['/patient-details']);
  }
}
